module.exports = __webpack_public_path__ + "img/ListaServicios-admin.38b99a7b.svg";